import { PropsWithChildren } from 'react';
import { Button } from '../Button';
import { Navigation } from 'navigation';
import background from '../images/error-background.jpg';
import { useDocumentTitle } from 'usehooks-ts';
import { FullscreenImageLayout } from '../FullscreenImageLayout';
import { CenteredSquaredContainer } from '../CenteredSquaredContainer';
import { Stack } from '../Stack';

type Props = PropsWithChildren<{
  title: string;
}>;

export function ErrorPageContainer({ title, children }: Props): JSX.Element {
  useDocumentTitle(title);

  return (
    <main>
      <FullscreenImageLayout src={background} logoClasses="block">
        <CenteredSquaredContainer className="pt-52 lg:pt-8">
          <Stack className="antialiased" gap={10}>
            <div className="text-pretty">{children}</div>

            <Button as="a" color="primary" className="w-56" href={Navigation.HOME_URL}>
              Zur Startseite
            </Button>
          </Stack>
        </CenteredSquaredContainer>
      </FullscreenImageLayout>
    </main>
  );
}
